import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/dist/client/image-component.js")